import edu from "./education/de";
import lib from "./library/de";
import al from "./assets/de";
import vm from "./videoMoments/de";
import iv from "./interview/de";
import lvl from "./level/de";
import pm from "./practice/de";
// Phase 5.3 — German (Deutsch)
const de = {
  footer: { forSchools: "Für Schulen", tagline: "Dein Leben wird zu deinem Sprachkurs.", eu: "Für die EU gemacht 🇪🇺 · DSGVO zuerst · Wir speichern niemals deine Fotos oder deine Stimme.", product: "Produkt", signIn: "Anmelden", getStarted: "Loslegen", legal: "Rechtliches", privacy: "Datenschutzerklärung", terms: "Nutzungsbedingungen" },
  cookie: { title: "Deine Privatsphäre ist uns wichtig 🍪", body: "GetFluentLoop verwendet notwendige Cookies, damit du angemeldet bleibst. Wir verkaufen niemals deine Daten und speichern niemals deine Originalfotos oder Sprachaufnahmen. Siehe unsere", link: "Datenschutzerklärung", end: ".", accept: "Akzeptieren", decline: "Ablehnen" },
  cefr: {"A1": "Ich kenne ein paar Wörter", "A2": "Einfache Alltagssätze", "B1": "Ich kann ein einfaches Gespräch führen", "B2": "Ich spreche ziemlich fließend", "C1": "Ich fühle mich sehr sicher", "C2": "Fast muttersprachlich"},
  landing: { imgAlt: "Lernende Person", streakBadge: {"one": "{count} Tag in Folge!", "other": "{count} Tage in Folge!"}, heroSub: "Lerne aus dem, was du siehst, denkst, sagst, liest und erlebst – während GetFluentLoop die Sprache an dein echtes Leben anpasst. Starte in Sekunden kostenlos.","freeTag": "GRATIS", "featJournal": "Sprachtagebuch", "featToday": "Intelligentes Heute", "descLoop": "Du siehst etwas? Mach ein Foto und lerne das Wort sofort.", "descFriend": "Dir geht etwas durch den Kopf? Sag es ganz natürlich – erzähl von deinem Leben in der Sprache, die du lernst.", "descLens": "Lies Schilder, Speisekarten, Gegenstände und Szenen um dich herum – und lerne daraus.", "descJournal": "Erzähl deinen Tag in eigenen Worten, gesprochen oder geschrieben. Hör ihn natürlich in deiner neuen Sprache.", "descToday": "Komm morgen wieder: Dein Lern-Gehirn baut die nächste kleine Lektion rund um das, was dir wichtig ist.", "mockLearned": "Heute gelernt", "mockGloss": "Der Baum ist sehr hoch."},
  dash: { freezeSaved: {"one": "🛡️ Ein Serien-Schutz hat deine {count}-Tage-Serie gerettet!", "other": "🛡️ Ein Serien-Schutz hat deine {count}-Tage-Serie gerettet!"},"hey": "Hallo {name} 👋", "heyAnon": "Hallo 👋", "learning": "Du lernst {lang} · Niveau {level}", "recap": "Wochenrückblick", "upgrade": "Auf Pro upgraden", "todayLoop": "Dein Loop für heute", "todayLoopSub": "Deine persönliche 5-Minuten-Session – jetzt starten", "classAssignments": "Klassenaufgaben", "viewAll": "Alle ansehen →", "continue": "Weiter", "start": "Starten", "allCaught": "Alles erledigt – gut gemacht! 🎉", "momentum": "Dein Schwung", "freezeHelp": "Serien-Schutz bewahrt deine Serie an einem verpassten Tag", "freezes": {"one": "{count} Schutz", "other": "{count} Schutz"}, "streakCalendar": "Serienkalender ansehen →", "totalXp": "XP gesamt", "wordsLearned": "gelernte Wörter", "dueForReview": "zum Wiederholen →", "captures": "Aufnahmen", "conversations": "Gespräche", "accentTrend": "Aussprache-Verlauf", "noScores": "Noch keine Werte – probier", "noScoresEnd": ".", "recent": "Letzte Aktivitäten", "nothingYet": "Noch nichts. Fang an zu entdecken!", "jumpBack": "Mach weiter, wo du warst"},
  nudge: {"streakTitle": {"one": "Halte deine {count}-Tage-Serie am Leben!", "other": "Halte deine {count}-Tage-Serie am Leben!"}, "streakSub": "Mach deinen Loop für heute, damit du sie nicht verlierst.", "startLoop": "Loop starten", "dueTitle": {"one": "{count} Wort ist zum Wiederholen fällig", "other": "{count} Wörter sind zum Wiederholen fällig"}, "dueSub": "Ein 2-Minuten-Loop verankert sie im Langzeitgedächtnis.", "reviewNow": "Jetzt wiederholen"},
  tour: {"t1": "Willkommen bei GetFluentLoop! 🎉", "b1": "Eine App, die deinen Alltag in deinen Sprachkurs verwandelt – jede Funktion füllt dieselbe Vokabelsammlung.", "t2": "Richte deine Kamera aus", "b2": "LanguageLoop macht aus allem um dich herum ein Wort: Foto machen und Wort, Beispielsatz und Aussprache erhalten.", "t3": "Übe ganz real", "b3": "Chatte mit deinem KI-Roommate, lass deine Aussprache bewerten, diskutiere ein Thema und teste dich mit deinen eigenen Wörtern.", "t4": "Dein Loop für heute", "b4": "Du weißt nicht, wo du anfangen sollst? Tipp auf den Loop für heute – jeden Tag eine persönliche 5-Minuten-Session.", "t5": "Bau eine Serie auf", "b5": "Übe täglich, damit deine Serie wächst – und sammle Serien-Schutz, damit ein voller Tag sie nie unterbricht.", "back": "Zurück", "next": "Weiter", "start": "Jetzt lernen", "skip": "Tour überspringen"},
  vocabSrc: {"manual": "Von dir hinzugefügt", "mission": "Mission", "word_explorer": "Wort-Explorer", "object_lens": "FluentLens · Gegenstand", "scene_lens": "FluentLens · Szene", "text_lens": "FluentLens · Text", "fluent_friend_live": "Live-Freund"},
  common: {
    save: "Speichern", cancel: "Abbrechen", add: "Hinzufügen", addSelected: "Auswahl hinzufügen",
    addAll: "Nützliche Wörter hinzufügen", delete: "Löschen", edit: "Bearbeiten", retake: "Foto wiederholen",
    scanAgain: "Erneut scannen", continue: "Weiter", back: "Zurück", next: "Weiter",
    close: "Schließen", loading: "Wird geladen…", search: "Suchen", logout: "Abmelden",
    settings: "Einstellungen", listen: "Anhören", stop: "Stopp", added: "Hinzugefügt",
  },
  nav: {
    educationadmin: "Bildungs-Admin",
    more: "Mehr",
    dashboard: "Übersicht", today: "Heute", languageloop: "LanguageLoop",
    fluentlens: "FluentLens", roommate: "Roommate", accentcoach: "AccentCoach",
    debategym: "DebateGym", quizforge: "QuizForge", story: "Geschichte",
    "vocab bank": "Vokabeln", "discovery lab": "Discovery Lab", assignments: "Aufgaben", myclasses: "Meine Klassen", teacher: "Lehrkraft", journal: "Tagebuch", friend: "Freund",
  },
  auth: { welcomeBack: "Willkommen zurück!", welcomeNew: "Willkommen bei GetFluentLoop! 🎉",
    signInTitle: "Willkommen zurück", signUpTitle: "Konto erstellen",
    signInSub: "Melde dich an, um weiterzulernen.", signUpSub: "In unter einer Minute loslernen.",
    continueWithGoogle: "Mit Google fortfahren", or: "ODER", yourName: "Dein Name",
    email: "E-Mail", password: "Passwort", iSpeak: "Ich spreche", imLearning: "Ich lerne",
    myLevel: "Mein Niveau", createAccount: "Konto erstellen", signIn: "Anmelden",
    acceptTerms: "Ich akzeptiere die AGB und die Datenschutzerklärung.",
    haveAccount: "Schon ein Konto?", noAccount: "Neu hier?",
  },
  onboarding: {
    allSet: "Alles bereit! 🎉",
    welcome: "Willkommen bei GetFluentLoop", title: "Lass uns einrichten",
    subtitle: "Sag uns, was du lernst.", iSpeak: "Ich spreche",
    imLearning: "Ich lerne", level: "Niveau", finish: "Mit dem Lernen beginnen",
    allSet: "Alles bereit! 🎉",
  },
  settings: {
    title: "Einstellungen", interfaceLanguage: "Sprache der Oberfläche",
    interfaceLanguageHelp: "Die Sprache von Menüs, Schaltflächen und Meldungen. Das ändert nicht, was du lernst.",
    learning: "Lernsprache", native: "Muttersprache", level: "Niveau",
    learningProfiles: "Lernprofile",
    learningProfilesHelp: "Mehrere Sprachen in einem Konto. Ein Profilwechsel ändert nur deinen persönlichen Lernkontext — Konto, Rolle und Schulen bleiben gleich.",
    addProfile: "Sprachprofil hinzufügen", switch: "Wechseln", active: "Aktiv",
    createAndSwitch: "Erstellen & wechseln", nameOptional: "Name (optional)",
    pickDifferent: "Wähle zwei verschiedene Sprachen zum Sprechen und Lernen.",
    profileSwitched: "Lernprofil gewechselt",
  },
  lens: {
    home: "FluentLens", tagline: "Richte deine Kamera auf die Welt und lerne die Sprache um dich herum.",
    textLens: "Text-Linse", objectLens: "Objekt-Linse", studyLens: "Lern-Linse",
    sceneLens: "Szenen-Linse", takePhoto: "Foto aufnehmen", uploadImage: "Bild hochladen",
    translate: "Übersetzen", explain: "Erklären", quizMe: "Teste mich", describe: "Beschreiben",
    identifyCount: "Erkennen & zählen", learnVocab: "Vokabeln lernen",
    saveScan: "Im Archiv speichern", archive: "Archiv", usefulVocab: "Nützliche Vokabeln",
    naturalTranslation: "Natürliche Übersetzung", gist: "Kernaussage", check: "Prüfen",
    addWord: "Wort hinzufügen", addRelated: "Verwandte Wörter hinzufügen", wordsAround: "Verwandte Wörter",
    whereThings: "Wo die Dinge sind", suggestedAnswer: "Vorgeschlagene Antwort",
  },
  mission: {
    speak: "Sprechen", type: "Tippen", startRecording: "Zum Sprechen tippen", stop: "Stopp",
    retry: "Erneut versuchen", usefulPhrases: "Nützliche Sätze", wordsToRemember: "Wörter zum Merken",
    completeMission: "Mission abschließen", nextStep: "Nächster Schritt", recap: "Lernzusammenfassung",
    showRecap: "Anzeigen", hideRecap: "Ausblenden", typeFirst: "Tippe deine erste Antwort, um zu starten.",
    speakFirst: "Tippe auf das Mikrofon und sprich deinen ersten Satz, um zu starten.",
    typeReply: "Tippe deine Antwort…",
  },
  home: {
    badge: "🇪🇺 In der EU entwickelt · Datenschutz zuerst · Global gedacht",
    heroPre: "Dein Leben wird", heroPost: "zu deinem", heroWord: "Sprachkurs",
    getStarted: "Loslegen", signIn: "Anmelden", dashboard: "Übersicht",
    tryFree: "LanguageLoop kostenlos testen", startLearning: "Mit dem Lernen beginnen",
    privacy: "Kein Foto und keine Aufnahme wird jemals gespeichert.",
    bundlesTitle: "Alles fließt in einen Lernkreislauf.",
    bundlesSub: "Entdecke überall ein Wort, erkunde es und behalte es. Jede Funktion teilt einen Vokabelspeicher, ein Gedächtnis dessen, was du weißt, und einen ruhigen Tagesplan.",
    priceSub: "Alles inklusive. Jederzeit kündbar.", startNow: "Jetzt starten",
  },
  pilot: {
    daysRemaining: { one: "noch {count} Tag", other: "noch {count} Tage" },
  },
  today: { dueSoon: "Bald fällig", overdue: "Überfällig", continueMission: "Setze deine Klassenmission fort", yourMission: "Deine Klassenmission", minutes: {"one": "~{count} Min.", "other": "~{count} Min."}, stepsProgress: "{done}/{total} Schritte", wordProgress: "Wort {n} / {total}", unlockPro: "Mit Pro freischalten", skipForNow: "Vorerst überspringen", weHeard: "Wir haben gehört:", skip: "Überspringen", snapHint: "Fotografiere einen Gegenstand in deiner Nähe, um ein neues Wort zu deiner Sammlung hinzuzufügen.", doLater: "Mache ich später", bonusXp: {"one": "+{count} Bonus-XP", "other": "+{count} Bonus-XP"}, micUnavailable: "Mikrofon nicht verfügbar.", scoringFailed: "Bewertung fehlgeschlagen.", paywallReason: "Die Aussprachebewertung ist Teil von GetFluentLoop Pro.",
    title: "Deine heutige Runde", subtitle: "Deine persönliche 5-Minuten-Einheit.",
    dayStreak: { one: "Tag in Folge", other: "Tage in Folge" }, streakText: {"one": "{count} Tag in Folge", "other": "{count} Tage in Folge"}, startLoop: "Heutige Runde starten", reveal: "Antwort zeigen",
    gotIt: "Gewusst", missedIt: "Verfehlt", sayItOut: "Sprich es laut aus", hearIt: "Anhören",
    skip: "Überspringen", continue: "Weiter", loopComplete: "Runde abgeschlossen!",
    loopCompleteToday: "Heutige Runde abgeschlossen!", comeBack: "Komm morgen wieder.",
    backToDashboard: "Zurück zur Übersicht", word: "Wort", reviewWords: "Wörter wiederholen",
    saySentence: "Sag einen Satz", captureNew: "Etwas Neues aufnehmen",
    openCamera: "Kamera öffnen", learnNewWord: "Lerne ein neues Wort", practiceAgain: "Erneut üben",
  },
  wordExplorer: {
    script: "Schrift",
    scriptSaved: "Schrift-Einstellung gespeichert",
    pos: {
      noun: "Nomen",
      verb: "Verb",
      adjective: "Adjektiv",
      adverb: "Adverb",
      pronoun: "Pronomen",
      preposition: "Präposition",
      conjunction: "Konjunktion",
      phrase: "Ausdruck",
      other: "Sonstiges",
      related: "verwandt",
    },
    labels: {
      present: "Präsens",
      past_compose: "Vergangenheit (passé composé)",
      past_preterite: "Vergangenheit (pretérito)",
      imperfect: "Imperfekt",
      future: "Futur",
      conditional: "Konditional",
      subjunctive: "Subjunktiv",
      singular: "Singular",
      plural: "Plural",
      nominative: "Nominativ",
      genitive: "Genitiv",
      dative: "Dativ",
      accusative: "Akkusativ",
      instrumental: "Instrumental",
      prepositional: "Präpositiv",
      present_imperfective: "Präsens (imperfektiv)",
      future_perfective: "Futur (perfektiv)",
      past: "Vergangenheit",
      imperative: "Imperativ",
      forms: "Formen",
      masculine: "maskulin",
      feminine: "feminin",
      neuter: "neutral",
      short_m: "Kurzform m.",
      short_f: "Kurzform f.",
      short_forms: "Kurzformen",
    },
    explore: "Erkunden",
    exploreWord: "„{word}“ erkunden",
    title: "Wort-Explorer",
    howChanges: "Wie sich dieses Wort verändert",
    seeMoreForms: "Mehr Formen",
    family: "Wortfamilie",
    usage: "Wie man es wirklich benutzt",
    traps: "Typische Fallen",
    examples: "Natürliche Beispiele",
    save: "Zum Wortschatz hinzufügen",
    saved: "Im Wortschatz gespeichert",
    aiAssisted: "KI-gestützte Formen",
    aiAssistedHelp: "Diese Formen wurden automatisch erzeugt und geprüft.",
    unlock: "Wort-Explorer mit Pro freischalten",
    unlockSub: "Alle nützlichen Formen, Wortfamilie, echter Gebrauch, typische Fallen und mehr Beispiele.",
    unlockCta: "Mit Pro freischalten",
    more: "Mehr Gebrauch & Beispiele",
    loading: "Wird erkundet…",
    failed: "Dieses Wort konnte nicht erkundet werden. Bitte Schreibweise prüfen.",
    back: "Wortschatz",
    listen: "Anhören",
    alsoMeans: "Auch",
  },
  vocab: { markKnown: "Als bekannt markieren",
    title: "Vokabeln", subtitle: "Jedes Wort, das du gelernt hast.", searchWords: "Wörter suchen…",
    all: "Alle", known: "Bekannt", learning: "Lerne ich", removed: "Entfernt", markKnown: "Als bekannt markieren",
    empty: "Noch keine Wörter. Nimm welche mit FluentLens auf!",
  },
  journal: {
    title: "Sprachtagebuch", tagline: "Sprich dein Leben. Lerne, es zu sagen.",
    speak: "Sprechen", type: "Tippen", recording: "Aufnahme… zum Stoppen tippen",
    typePlaceholder: "Schreibe in deiner Sprache…",
    intro: "Erzähl von deinem Tag, deinen Plänen oder Gefühlen — in deiner Sprache.",
    review: "Prüfe deinen Gedanken", reviewHelp: "Prüfe die Transkription und korrigiere vor der Übersetzung.",
    retry: "Neu aufnehmen", seeHowToSay: "Zeig, wie man es sagt",
    whatYouSaid: "Was du gesagt hast", howToSay: "So sagt man es auf {lang}",
    practice: "Übe es zu sagen", practicing: "Deine Übung wird aufgenommen…", playYours: "Deinen Versuch anhören",
    usefulWords: "Nützliche Wörter", usefulPhrases: "Nützliche Wendungen", grammar: "Bemerkenswerte Grammatik",
    actions: "Mögliche Aufgaben", saveEntry: "Im Tagebuch speichern", saved: "In deinem Tagebuch gespeichert",
    archive: "Dein Tagebuch", empty: "Noch keine Einträge — sprich oder tippe deinen ersten Gedanken.",
    newEntry: "Neuer Eintrag", rename: "Umbenennen", deleted: "Eintrag gelöscht",
    micDenied: "Mikrofon nicht verfügbar — tippe stattdessen.", analyzing: "Die natürliche Formulierung wird gesucht…",
    transcribing: "Hört zu…",
  },
  friend: {
    live: {
      "premium": "Fluent Friend ist eine Premium-Funktion.",
      "voiceUnavailable": "Stimme gerade nicht verfügbar.",
      "genericError": "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
      "start": "Live-Gespräch starten",
      "tag": "Live",
      "intro": "Sprich direkt in der Sprache, die du lernst. Fluent Friend hält das Gespräch am Laufen. Wenn du nicht weiterweißt, nutze „Hilf mir, es zu sagen“.",
      "ideas": "Ideen zum Start",
      "speak": "Sprechen",
      "stop": "Stopp",
      "type": "Schreib in der Sprache, die du lernst…",
      "help": "Hilf mir, es zu sagen",
      "helpTitle": "Sag es in deiner Sprache",
      "helpPlaceholder": "Sag oder schreib, was du meinst…",
      "helpGo": "Zeig mir, wie man es sagt",
      "helped": "Du wolltest sagen",
      "end": "Gespräch beenden",
      "voice": "Stimme des Freundes",
      "listening": "Ich höre zu…",
      "understanding": "Verstehe…",
      "thinking": "Denke nach…",
      "retry": "Erneut versuchen",
      "replyFailed": "Fluent Friend konnte gerade nicht antworten – deine Nachricht ist sicher.",
      "sttFailed": "Das haben wir nicht verstanden. Versuch es noch einmal oder schreib.",
      "meaning": "Bedeutung zeigen",
      "saved": "Gespräch gespeichert.",
      "recapTitle": "Was du geübt hast",
      "keep": "Ausdrücke zum Behalten",
      "addAll": "Alle nützlichen hinzufügen",
      "moreNatural": "Eine Sache, die man natürlicher sagt",
      "handledWell": "Etwas, das du gut gemacht hast",
      "practiceAgain": "Lohnt sich zu üben",
      "starter": {
        "day": "Erzähl von deinem Tag",
        "plans": "Was hast du vor?",
        "happened": "Ist etwas Interessantes passiert?",
        "work": "Über Arbeit oder Studium reden?",
        "forward": "Worauf freust du dich?"
      }
    },
    title: "Fluent Friend", tagline: "Sprich über dein Leben. Lerne durch das Gespräch.",
    intro: "Sprich natürlich in deiner Sprache. Fluent Friend hilft dir, es auf {lang} zu sagen — und führt das Gespräch dort weiter.",
    introText: "Schreib natürlich in deiner Sprache. Sag, was du wirklich ausdrücken möchtest — Fluent Friend hilft dir, es auf {lang} zu sagen, und führt das Gespräch dort weiter.",
    speak: "Sprechen", type: "Tippen", send: "Senden", placeholder: "Sag etwas in deiner Sprache…",
    reviewHint: "Prüfe, was du gesagt hast, und sende.", youCouldSay: "Du könntest sagen",
    showMeaning: "Bedeutung zeigen", hideMeaning: "Bedeutung ausblenden",
    recap: "Was du geübt hast", newChat: "Neues Gespräch", conversations: "Gespräche",
    empty: "Noch keine Gespräche — erzähl einfach von deinem Tag.",
    startersTitle: "Nicht sicher, wo du anfangen sollst?",
    starters: ["Erzähl von deinem Tag", "Was beschäftigt dich?", "Was hast du vor?", "Reden wir über die Arbeit?", "Erzähl mir etwas Schönes", "Worauf freust du dich?"],
    words: "Nützliche Wörter", phrases: "Nützliche Wendungen", expressions: "Natürliche Ausdrücke",
    grammar: "Bemerkenswerte Grammatik", practiceAgain: "Nochmal üben",
    thinking: "Fluent Friend antwortet…", recording: "Aufnahme… zum Stoppen tippen",
    micDenied: "Mikrofon nicht verfügbar — tippe stattdessen.",
  },
  teacher: { dashboard: "Lehrer-Dashboard", myClasses: "Meine Klassen" },
  education: {
    title: "FluentLoop für Bildung",
    pilotLine: "90-Tage-Schulpilot — kostenlos für verifizierte Schulen.",
    apply: "Für den 90-Tage-Pilot bewerben", submitting: "Wird gesendet…",
  },
  assignments: {
    title: "Meine Aufgaben", subtitle: "Missionen, die deine Lehrkraft dir gegeben hat.",
    empty: "Gerade keine Aufgaben 🎉", emptySub: "Wenn deine Lehrkraft eine Mission zuweist, erscheint sie hier.",
    doTodayLoop: "Heutige Runde machen", toDo: "Zu erledigen", inProgress: "In Arbeit", completed: "Erledigt",
    start: "Starten", continue: "Fortsetzen", done: "Fertig", late: "(verspätet)",
    overdue: "Überfällig", dueToday: "Heute fällig", dueSoon: "Bald fällig", scheduled: "Geplant",
  },
  label: {
    gist: "Kernaussage", vocabulary: "Vokabeln", usefulPhrases: "Nützliche Sätze", grammar: "Grammatik",
    verbs: "Verben", adjectives: "Adjektive", idioms: "Redewendungen & Kollokationen", relatedWords: "Verwandte Wörter",
    example: "Beispiel", naturalTranslation: "Natürliche Übersetzung", whereThings: "Wo die Dinge sind",
    reanalyze: "Neu analysieren", save: "Speichern", plural: "Plural",
  },
  missionRun: {
    breadcrumb: "Aufgaben", notAvailable: "Diese Mission ist für dich nicht verfügbar.",
    backToAssignments: "Zurück zu den Aufgaben", complete: "Mission abgeschlossen!",
    completeDesc: "Du hast {title} abgeschlossen.",
    myAssignments: "Meine Aufgaben", dashboard: "Übersicht", yourClass: "Deine Klasse",
    stepOf: "Schritt {current} von {total}", optional: "optional",
    back: "Zurück", nextStep: "Nächster Schritt", continueBonus: "Weiter zum Bonus",
    completeMission: "Mission abschließen", finishEarly: "Ich bin fertig — Mission abschließen",
    keepWords: "Diese Wörter für dein eigenes Üben behalten?", saveToBank: "In meiner Vokabelbank speichern", notNow: "Jetzt nicht", savedToBank: "In deiner Vokabelbank gespeichert.", backToClass: "Zurück zur Klasse", cantSave: "Diese Wörter können nicht in deiner Vokabelbank gespeichert werden, weil die Sprache dieser Mission keine deiner Lernsprachen ist.", saveFailed: "Die Wörter konnten nicht gespeichert werden. Bitte versuche es erneut.",
  },
  lensDesc: {
    text: "Übersetze schwierige Passagen und verstehe Vokabeln und Grammatik.",
    object: "Finde heraus, wie etwas heißt, und lerne die Sprache drumherum.",
    scene: "Sieh dir die ganze Szene an: beschreibe sie, zähle Dinge und lerne die Sprache darum.",
    study: "Mach aus dem Lesen der echten Welt Verständnisübungen.",
    archiveSub: "Alte Scans erneut öffnen, Vokabeln wiederholen, Lernsitzungen wiederholen.",
    hintText: "Richte auf ein Buch, Schild, Menü oder einen Brief", hintObject: "Richte auf ein Objekt, eine Pflanze oder ein Tier",
    hintScene: "Richte auf ein Essen, einen Tisch, Raum oder eine Landschaft", captureHelp: "Mach ein Foto oder lade eins hoch.",
    subText: "Scanne einen Text, um ihn zu übersetzen, zu erklären oder zu lernen.",
    subObject: "Richte auf etwas, um seinen Namen und die Sprache drumherum zu lernen.",
    subScene: "Sieh dir die ganze Szene an. Lerne die Sprache darum herum.",
    subStudy: "Scanne einen Text und übe, ihn zu verstehen.",
    captureSub: "Mach oder lade ein Foto von irgendeinem Objekt hoch, um sein Wort zu lernen.",
  },
  todayHelp: {
    refresh: "Frische auf, was verblasst", score: "Bewerte deine Aussprache",
    snap: "Fotografiere ein Objekt", proFeature: "Pro-Funktion", proScoring: "Aussprachebewertung ist eine Pro-Funktion",
  },
  capture: {
    title: "Was ist um dich herum?", reading: "Die Welt wird gelesen…",
    pointHint: "Richte auf eine Tasse, einen Baum, einen Hund…", anything: "Alles funktioniert.",
    learnMe: "Lern mich", savedToBank: "In deinen Vokabeln gespeichert", shareCard: "Teilen-Karte",
    building: "Wird erstellt…", capReached: "Du hast deine kostenlosen Tagesaufnahmen erreicht.",
    keepStreak: "Halte deine Serie am Leben!", signUpFree: "Kostenlos registrieren", close: "Schließen",
    couldNotRead: "Dieses Bild konnte nicht gelesen werden. Versuche ein anderes.",
  },
  review: {
    title: "Wiederholen", tagline: "Behalte, was zählt.",
    progress: "{n} von {total}",
    dueCount: { one: "1 Wort ist bereit zum Wiederholen.", other: "{count} Wörter sind bereit zum Wiederholen." },
    recentCount: { one: "Übe 1 neues Wort.", other: "Übe {count} neue Wörter." },
    allDue: "Alle fälligen", all: "Alle", start: { one: "Starten · 1 Karte", other: "Starten · {count} Karten" },
    caughtUp: "Du bist auf dem neuesten Stand.", nothingDue: "Gerade gibt es nichts zu wiederholen.", practiceRecent: "Neue Wörter üben",
    reveal: "Aufdecken", again: "Nochmal", gotIt: "Gewusst", listen: "Anhören",
    type: { recognition: "Was bedeutet das?", recall: "Wie sagt man das?", context: "Welches Wort passt?", listening: "Hör zu – was ist das?", typed: "Schreib es aus dem Gedächtnis" },
    typed: { label: "Gib deine Antwort ein", placeholder: "Auf {lang} eingeben", check: "Prüfen", correct: "Richtig", notQuite: "Nicht ganz", yourAnswer: "Deine Antwort", answer: "Antwort", showAnswer: "Antwort zeigen", suggestAgain: "Lohnt einen zweiten Blick – „Nochmal“ bringt es früher zurück.", checkFailed: "Prüfen hat nicht geklappt – versuch es nochmal." },
    complete: "Wiederholung abgeschlossen", reviewed: "Wiederholt", remembered: "Gewusst", anotherLook: "Nochmal ansehen",
    nextIn: { one: "Nächste Wiederholung in 1 Tag.", other: "Nächste Wiederholung in {count} Tagen." },
    done: "Fertig", backToday: "Zurück zu Heute", todayLink: { one: "Merken · 1 Wort fällig", other: "Merken · {count} Wörter fällig" },
    voiceUnavailable: "Die Stimme ist gerade nicht verfügbar.", saveFailed: "Speichern fehlgeschlagen – bitte erneut versuchen.",
  },
  lc: {
    "title": "Deine 5 Minuten",
    "subtitle": "Gemacht aus dem, was du gerade lernst",
    "cold": "Dein Tagesweg wird persönlicher, sobald FluentLoop lernt, was dir wichtig ist.",
    "forYou": "Für dich heute",
    "assigned": "Zugewiesen",
    "reason": {
      "due": "Kommt genau zur richtigen Zeit zurück",
      "weak": "Lohnt sich zu wiederholen",
      "activation": "Schon gesehen, aber noch nicht benutzt",
      "relevant": "Kürzlich gespeichert",
      "recently_saved": "Kürzlich gespeichert",
      "stretch": "Einen Schritt weiter",
      "function_gap": "Eine nützliche Fähigkeit zum Üben",
      "skill": "Eine nützliche Fähigkeit zum Üben"
    },
    "kind": {
      "recall": "Erinnern",
      "retrieve": "Erinnern",
      "use_it": "Benutzen",
      "situation": "Situation"
    },
    "howSay": "Wie sagt man das?",
    "write": "Schreib deine Antwort…",
    "check": "Prüfen",
    "skip": "Überspringen",
    "notUseful": "Für mich nicht nützlich",
    "next": "Weiter",
    "natural": "Natürlich",
    "tip": "Tipp",
    "alreadyNatural": "Dein Satz klingt schon natürlich.",
    "example": "Beispiel",
    "saved": "Gespeichert",
    "useItTpl": "Benutze „{word}“ in einem Satz.",
    "useItTopicTpl": "Benutze „{word}“ in einem Satz über {topic}.",
    "situationTpl": "{function}: Schreib 1–2 Sätze über {topic}.",
    "doneTitle": "Das reicht für heute.",
    "recalled": "{count} erinnert",
    "used": "{count} benutzt",
    "situations": "{count} Situation geübt",
    "keepGoing": "Weitermachen",
    "reviewAll": "Alle fälligen Wörter wiederholen ({count})",
    "sayAloud": "Einen Satz laut sagen",
    "snapWord": "Ein neues Wort fotografieren",
    "alsoToday": "Außerdem heute",
    "progress": "{n} von {total}",
    "loading": "Deine 5 Minuten werden vorbereitet…",
    "fn": {
      "asking_question": "Eine Frage stellen",
      "requesting": "Um etwas bitten",
      "explaining_problem": "Ein Problem erklären",
      "describing": "Etwas beschreiben",
      "narrating_past": "Erzählen, was passiert ist",
      "making_plans": "Pläne machen",
      "apologizing": "Sich entschuldigen",
      "agreeing_disagreeing": "Zustimmen oder widersprechen",
      "expressing_preference": "Sagen, was du lieber magst",
      "giving_opinion": "Deine Meinung sagen",
      "clarifying": "Etwas klären",
      "small_talk": "Smalltalk"
    },
    "topic": {
      "home": "Zuhause",
      "work": "Arbeit",
      "study": "Lernen",
      "food": "Essen",
      "travel": "Reisen",
      "transport": "Unterwegs sein",
      "shopping": "Einkaufen",
      "social_life": "Freunde und Pläne",
      "health_everyday": "Wohlbefinden im Alltag",
      "money_everyday": "Alltagskosten",
      "hobbies": "Hobbys",
      "culture": "Kultur",
      "nature": "Natur",
      "technology": "Technik",
      "everyday_life": "den Alltag"
    }
  },
  errors: {
    generic: "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
    couldNotSave: "Konnte nicht gespeichert werden. Versuche es erneut.",
  },
};
de.pm = pm;
de.lvl = lvl;
de.iv = iv;
de.vm = vm;
de.edu = edu;
de.lib = lib;
de.al = al;
export default de;
